// extracted by mini-css-extract-plugin
export default {"addTopGap":"_dd51b1c4","titleContainer":"_bd2eb27f","titleWrapper":"_de45912b","title":"_b6a47258","subtitle":"_fcd9195c","viewMore":"_c645f860"};